import { IconAI, Inline, Text } from 'braid-design-system';

import * as styles from './CareerFeedAIHeading.css';

export const CareerFeedAIHeading = ({
  headingText,
}: {
  headingText: string;
}) => (
  <Inline space="xsmall" alignY="center">
    <Text size="large" weight="medium" icon={<IconAI tone="brandAccent" />}>
      <span className={styles.gradientText}>{headingText}</span>
    </Text>
  </Inline>
);
